import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { GAME_JOIN_LIST, GAME_JOIN_PLAYLIST_LIST } from 'src/constants/queryKeys';

export const networkGetGameJoinInfo = async (gameJoinid) => {
  const res = await axiosInstance.post(`GameJoinApplication/Info/${gameJoinid}`);
  return res;
};

export const networkGetGameJoinList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`GameJoinApplication/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchGameJoinList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [GAME_JOIN_LIST, pageIndex, payload],
    queryFn: () => networkGetGameJoinList(payload, pageIndex, pageSize),
  });
}

export const networkCreateGameJoin = async (data) => {
  const res = await axiosInstance.post('GameJoinApplication/Insert', data);
  return res;
};

export const networkUpdateGameJoin = async (gameJoinid, data) => {
  const res = await axiosInstance.post(`GameJoinApplication/Update/${gameJoinid}`, data);
  return res;
};

export const networkRemoveGameJoin = async (gameJoinid) => {
  const res = await axiosInstance.post(`GameJoinApplication/Remove/${gameJoinid}`);
  return res;
};

// --------------------------------------------------------------------------------

export const networkGetGameJoinCallbackList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`GameJoinApplicationCallBack/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchGameJoinCallbackList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['game-join-callback-list', pageIndex, payload],
    queryFn: () => networkGetGameJoinCallbackList(payload, pageIndex, pageSize),
  });
}

// --------------------------------------------------------------------------------

export const networkGetGameJoinPlaylistInfo = async (playlistId) => {
  const res = await axiosInstance.post(`GameJoinApplicationPlayList/Info/${playlistId}`);
  return res;
};

export const networkGetGameJoinPlaylistList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`GameJoinApplicationPlayList/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchGameJoinPlaylistList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [GAME_JOIN_PLAYLIST_LIST, payload, pageIndex],
    queryFn: () => networkGetGameJoinPlaylistList(payload, pageIndex, pageSize),
  });
}

export const networkCreateGameJoinPlaylist = async (data) => {
  const res = await axiosInstance.post('GameJoinApplicationPlayList/Insert', data);
  return res;
};

export const networkUpdateGameJoinPlaylist = async (playlistId, data) => {
  const res = await axiosInstance.post(`GameJoinApplicationPlayList/Update/${playlistId}`, data);
  return res;
};

export const networkRemoveGameJoinPlaylist = async (playlistId) => {
  const res = await axiosInstance.post(`GameJoinApplicationPlayList/Remove/${playlistId}`);
  return res;
};
